import styled, { css } from 'styled-components';

export const PrimaryButton = styled.button`
  ${({ $width, $size }) => css`
    --mouse-x: 0;
    --mouse-y: 50;
    align-items: center;
    background-image: radial-gradient(circle, #2E93EE 1.9%, #2E93EE 5.89%, #415ACA 40.83%, #5421A5 77.87%, #551CA2 83%, #2E1451 116.37%);
    background-position: calc((100 - var(--mouse-x, 0)) * 1%) calc((100 - var(--mouse-y, 0)) * 1%);
    background-size: 200% 200%;
    border-radius: 1000px;
    border: none;
    cursor: pointer;
    display: flex;
    gap: 16px;
    justify-content: center;
    padding: 0 31px;

    ${$size === 'lg' && css`
      height: 56px;
    `}
    ${$size === 'md' && css`
      height: 40px;
    `}

    ${$width === 'fit' && css`
      min-width: fit-content;
    `}

    ${$width === 'full' && css`
      flex: 1;
      max-width: 100%;
      width: 100%;
    `}
  `}
`;

export const PrimaryLabel = styled.span`
  ${({ theme, $size }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    padding: 0;

    ${$size === 'lg' && css`
      font-size: ${theme.v2.font.sizes.sm2};
    `}

    ${$size === 'md' && css`
      font-size: ${theme.v2.font.sizes.xs};
    `}
  `}
`;


export const SecondaryButton = styled.button`
  ${({ theme, $width, $size }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 1000px;
    border: none;
    cursor: pointer;
    display: flex;
    gap: 16px;
    justify-content: center;
    padding: 0 32px;

    ${$size === 'lg' && css`
      height: 56px;
    `}
    ${$size === 'md' && css`
      height: 40px;
    `}

    ${$width === 'fit' && css`
      min-width: fit-content;
    `}

    ${$width === 'full' && css`
      flex: 1;
      max-width: 100%;
      width: 100%;
    `}
  `}
`;

export const SecondaryLabel = styled.span`
  ${({ theme, $size }) => css`
    --mouse-x: 0;
    --mouse-y: 50;
    align-items: center;
    background-image: radial-gradient(circle, #2E93EE 1.9%, #2E93EE 5.89%, #415ACA 40.83%, #5421A5 77.87%, #551CA2 83%, #2E1451 116.37%);
    background-position: calc((100 - var(--mouse-x, 0)) * 1%) calc((100 - var(--mouse-y, 0)) * 1%);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.medium};

    ${$size === 'lg' && css`
      font-size: ${theme.v2.font.sizes.sm2};
    `}

    ${$size === 'md' && css`
      font-size: ${theme.v2.font.sizes.xs};
    `}
  `}
`;
